import React from 'react';
import { useDispatch } from 'react-redux';

import { setCreditCardData } from './transferSlice';

import CreditCardForm from './CreditCardForm';

export default function CreditCard() {
  const dispatch = useDispatch();

  const handleSubmit = (cardDetails) => dispatch(setCreditCardData(cardDetails));

  return <CreditCardForm onSubmit={handleSubmit} />;
}
